<template>
  <div class="legal-page">
    <LegalPageHeader />

    <div class="legal-shell">
      <main class="legal-main">
        <div class="legal-title-block">
          <p class="legal-eyebrow">CuraScript</p>
          <h1 class="legal-page-title">Privacy Policy</h1>
          <p class="legal-lede">
            How we collect, use, disclose, and protect information when you use our service.
          </p>
        </div>

        <b-card class="legal-card" no-body>
          <div class="legal-card-body">
            <article class="legal-article">
              <p>
                CuraScript (Pty) Ltd built the CuraScript app as a free service. This SERVICE is provided by
                CuraScript and is intended for use as is.
              </p>
              <p>
                This page is used to inform users regarding our policies with the collection, use, and disclosure
                of Personal Information if anyone decides to use our Service.
              </p>
              <p>
                By choosing to use our Service, you agree to the collection and use of information in relation to
                this Privacy Policy. The Personal Information that we collect is used for providing and improving the
                Service. We do not use or share your information with anyone except as described in this Privacy
                Policy.
              </p>
              <p>
                The terms used in this Privacy Policy have the same meanings as in our
                <router-link :to="{ name: 'terms-and-conditions' }" class="legal-link">Terms &amp; Conditions</router-link
                >, unless otherwise defined here.
              </p>

              <h2>Information Collection and Use</h2>
              <p>
                For a better experience, while using our Service, we may require you to provide us with certain
                personally identifiable information, including but not limited to Name, contact details, location
                details. The information that we request will be retained by us and used as described in this
                privacy policy.
              </p>
              <p>The app does use third party services that may collect information used to identify you.</p>
              <p class="mb-1">Link to privacy policy of third party service providers used by the app:</p>
              <ul>
                <li>
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="legal-link"
                    >Google Play Services</a
                  >
                </li>
              </ul>

              <h2>Log Data</h2>
              <p>
                We want to inform you that whenever you use our Service, in a case of an error in the app we
                collect data and information (through third party products) on your phone called Log Data. This
                Log Data may include information such as your device Internet Protocol (&ldquo;IP&rdquo;) address,
                device name, operating system version, the configuration of the app when utilizing our Service, the
                time and date of your use of the Service, and other statistics.
              </p>

              <h2>Cookies</h2>
              <p>
                Cookies are files with a small amount of data that are commonly used as anonymous unique
                identifiers. These are sent to your browser from the websites that you visit and are stored on your
                device&apos;s internal memory.
              </p>
              <p>
                This Service does not use these &ldquo;cookies&rdquo; explicitly. However, the app may use third
                party code and libraries that use &ldquo;cookies&rdquo; to collect information and improve their
                services. You have the option to either accept or refuse these cookies and know when a cookie is
                being sent to your device. If you choose to refuse our cookies, you may not be able to use some
                portions of this Service.
              </p>

              <h2>Service Providers</h2>
              <p>We may employ third-party companies and individuals due to the following reasons:</p>
              <ul>
                <li>To facilitate our Service;</li>
                <li>To provide the Service on our behalf;</li>
                <li>To perform Service-related services; or</li>
                <li>To assist us in analyzing how our Service is used.</li>
              </ul>
              <p>
                We want to inform users of this Service that these third parties have access to your Personal
                Information. The reason is to perform the tasks assigned to them on our behalf. However, they are
                obligated not to disclose or use the information for any other purpose.
              </p>

              <h2>Security</h2>
              <p>
                We value your trust in providing us your Personal Information. We strive to use commercially
                acceptable means of protecting it, including secure data transmission and access controls.
              </p>
              <p>
                However, please note that no method of transmission over the internet or method of electronic
                storage is 100% secure, and we cannot guarantee absolute security.
              </p>

              <h2>Links to Other Sites</h2>
              <p>
                This Service may contain links to other sites. If you click on a third-party link, you will be
                directed to that site. Note that these external sites are not operated by us. Therefore, we strongly
                advise you to review the Privacy Policy of these websites. We have no control over and assume no
                responsibility for the content, privacy policies, or practices of any third-party sites or services.
              </p>

              <h2>Children&rsquo;s Privacy</h2>
              <p>CuraScript does not address anyone under the age of 18.</p>
              <p>
                We do not knowingly collect personally identifiable information from children under 18. If we become
                aware that a child has provided us with personal information, we will immediately delete it.
              </p>
              <p>
                If you are a parent or guardian and believe that your child has provided personal information,
                please contact us so we can take appropriate action.
              </p>

              <h2>Changes to This Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. You are advised to review this page
                periodically for any changes.
              </p>
              <p>Any updates will be posted on this page and are effective immediately after they are published.</p>

              <h2>Contact Us</h2>
              <p>If you have any questions or suggestions about this Privacy Policy, do not hesitate to contact us:</p>
              <p class="mb-0">
                Email:
                <a href="mailto:info@curascript.co.za" class="legal-link">info@curascript.co.za</a>
              </p>

              <h2>Consent</h2>
              <p class="mb-0">By using CuraScript, you consent to this Privacy Policy and agree to its terms.</p>
            </article>
          </div>
        </b-card>
      </main>
    </div>

    <LegalPageFooter active="privacy" />
  </div>
</template>

<script>
import LegalPageHeader from '@/components/legal/LegalPageHeader.vue';
import LegalPageFooter from '@/components/legal/LegalPageFooter.vue';

const PAGE_TITLE = 'Privacy Policy | CuraScript';

export default {
  name: 'PrivacyPolicy',
  components: {
    LegalPageHeader,
    LegalPageFooter,
  },
  data() {
    return {
      previousDocumentTitle: '',
    };
  },
  mounted() {
    this.previousDocumentTitle = document.title;
    document.title = PAGE_TITLE;
  },
  beforeDestroy() {
    document.title = this.previousDocumentTitle || 'Cura Script';
  },
};
</script>
